export enum RaceStatus {
  Open = 'Open',
  Abandoned = 'Abandoned',
  Released = 'Released',
  Interim = 'Interim',
  Closed = 'Closed',
}
